import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, CardTitle, ComboBox, Drawer, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RegionDrawer = ({ show, onClose, provinces, onChangeRegion, selectedCountry, selectedProvince }) => {
  const { t } = useTranslation()
  const [province, setProvince] = useState('')

  useEffect(() => {
    if (show) {
      setProvince(selectedProvince)
    }
  }, [show, selectedProvince])

  const handleClick = () => {
    onChangeRegion(province)
  }

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Región')}</CardTitle>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Selecciona la región desde la que el cliente devolverá los productos y así mostrar los métodos de devolución disponibles y su coste asociado:'
          )}
        </Text>
        <InputWithLabel label={t('País')} value={selectedCountry} fullWidth disabled />
        {provinces?.length > 0 && (
          <ComboBox
            label={t('Provincia')}
            value={province}
            menuItems={provinces}
            handleChange={e => setProvince(e.target.value)}
            fullWidth
          />
        )}
        <Styles.ButtonContainer>
          <Button onClick={handleClick} disabled={!province}>
            {t('Guardar')}
          </Button>
          {(selectedProvince || province) && (
            <Button onClick={onClose} variant="outlined">
              {t('Cancelar')}
            </Button>
          )}
        </Styles.ButtonContainer>
      </Styles.Container>
    </Drawer>
  )
}

export default RegionDrawer
